import {observable, action, computed, makeObservable} from 'mobx';
import {DesignScreen} from './Design/stores/DesignScreen';
import {PersonalMenuScreen} from './PersonalMenu/stores/PersonalMenuScreen';
import {TreeDesignScreen} from './Design/derivatives/TreeDesign/stores/TreeDesignScreen';
import {ColumnsDesignScreen} from './Design/derivatives/ColumnsDesign/stores/ColumnsDesignScreen';
import {SplittedDesignScreen} from './Design/derivatives/SplittedDesign/stores/Screen';
import {ContainersScreen} from './Containers/stores/ContainersScreen';
import {TemplateScreen} from './TemplateReport/stores/TemplateScreen';
import {PackagesScreen} from './Packages/stores/PackagesScreen';
import {SystemReportScreen} from './SystemReport/stores/SystemReportScreen';
import * as screenTypes from '../../constants/ScreenTypes';

export class ScreensStore {
    @observable selectedScreenKey;
    screens;
    //panelType;
    isReloadNeeded;
    initialized;
    oneScreenStore;

    constructor(/*data, selectedScreenKey, panelType*/) {
        makeObservable(this);
        this.screens = {};
    }

    initScreens(data) {
        this.oneScreenStore = false;
        for (const name in data) {
            switch (name) {
                //case panelType === panelTypes.DESIGN :
                case screenTypes.design.TREE: {
                    this.screens[name] = new TreeDesignScreen(data[name], name);
                    break;
                }

                case screenTypes.design.COLUMNS: {
                    // special check for splitted screen
                    if (data[name].isSplitted) {
                        this.screens[name] = new SplittedDesignScreen(data[name], name);
                    } else {
                        this.screens[name] = new ColumnsDesignScreen(data[name], name);
                    }
                    break;
                }

                case screenTypes.design.SUBLEVELS:
                case screenTypes.menu.MAINMENU:
                case screenTypes.design.ACTIVATIONS: {
                    this.screens[name] = new DesignScreen(data[name], name);
                    break;
                }
                case screenTypes.menu.PERSONALMENU: {
                    this.screens[name] = new PersonalMenuScreen(data[name], name);
                    break;
                }

                case screenTypes.report.CONTAINERS: {
                    this.screens[name] = new ContainersScreen(data[name], name);
                    break;
                }

                case screenTypes.report.TEMPLATES: {
                    this.screens[name] = new TemplateScreen(data[name], name);
                    break;
                }

                case screenTypes.report.SYSTEMFORMATS: {
                    this.screens[name] = new SystemReportScreen(data[name], name);
                    break;
                }
                case screenTypes.design.PACKAGES: {
                    this.screens[name] = new PackagesScreen(data[name], name);
                    this.oneScreenStore = true;
                    break;
                }
            }
        }
        this.initialized = true;
    }

    clearScreens() {
        this.screens = {};
        this.selectedScreenKey = null;
        this.initialized = false;
    }

    setInitialized(value) {
        this.initialized = false;
    }

    @action setSelectedScreenKey(value) {
        this.selectedScreenKey = value;
    }

    @computed get selectedScreen() {
        return this.screens[this.selectedScreenKey];
    }
}

export const screensStore = new ScreensStore();
